import React from "react";
import Search from "../../global/search/search";
import { useNavigate } from "react-router-dom";
import PaginationSlice from "../../global/pagination/pagination";

const Items = ({ list, search = true, link, pagination }) => {
  const navigate = useNavigate();
  return (
    <div className="container ">
      <div className="mb--large pad--small   ">
        {search && <Search title="Search For Diseases" />}
        <div className="main-items pad--mid">
          {list.map((item, index) => {
            return (
              <div className="card" key={index}>
                <div className="content-card">
                  <div className="img">
                    <img src={item.img[0]} />
                  </div>
                  <div className="about-card">
                    <h2>{item.title}</h2>
                    <p>{item.paragraph}</p>
                    <button
                      onClick={() =>
                        navigate(`${link}/${item.id}`, { state: item })
                      }
                    >
                      Details
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {pagination && <PaginationSlice />}
      </div>
    </div>
  );
};

export default Items;
